// DJB-280: where a fixed-position popover goes, relative to the viewport
// rectangle of the element it belongs to (the match panel). The popover is
// rendered in a portal on <body> with position: fixed, so it sits above the
// sticky header, the side rail and the mobile menu and is never clipped by
// a card; this only decides its top / left and which way the tail points.
//
// - above the anchor when it fits there, otherwise below it (a card right
//   under the header or at the top of the page after scrolling); when it
//   fits nowhere it goes below and the viewport scrolls
// - horizontally centred on the anchor, kept `margin` px inside the
//   viewport; the tail then points at the anchor's centre (`tailX`, in px
//   from the popover's left edge) instead of staying in the middle
export const POPOVER_GAP = 12;
export const POPOVER_MARGIN = 16;

const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));

export const placePopover = (anchor, popover, viewport, { gap = POPOVER_GAP, margin = POPOVER_MARGIN } = {}) => {
  const width = Math.min(popover.width, Math.max(0, viewport.width - 2 * margin));
  const height = popover.height;
  const roomAbove = anchor.top - gap - margin;
  const roomBelow = viewport.height - anchor.bottom - gap - margin;
  const fitsAbove = roomAbove >= height;
  const fitsBelow = roomBelow >= height;
  const placement = fitsAbove || (!fitsBelow && roomAbove > roomBelow) ? 'above' : 'below';
  const top = placement === 'above' ? anchor.top - gap - height : anchor.bottom + gap;
  const anchorCenter = anchor.left + anchor.width / 2;
  const left = clamp(anchorCenter - width / 2, margin, viewport.width - margin - width);
  // keep the tail inside the rounded corners
  const tailX = clamp(anchorCenter - left, 24, Math.max(24, width - 24));
  return { placement, top: Math.round(top), left: Math.round(left), tailX: Math.round(tailX), width };
};
